import sagasPersonal from './sagas.personal'
import sagasVmp from './sagas'

export default function* init() {
  const app = window.APP_TYPE
  if (app === 'personal') {
    yield sagasPersonal
    return
  }

  yield sagasVmp
}
